// extracted by mini-css-extract-plugin
module.exports = {"default":"button_default__3bFIW","invert":"button_invert__1QLb3","bold":"button_bold__17Ft7"};